<template>
  <div class="nine_field_resume" v-show="showFlag">
    <header>
      <img :src="bannerUrl" alt="" width="100%" />
    </header>
    <div class="nine_field_resume_content">
      <div class="nine_field_resume_container">
        <van-field
          v-model="nineField.name"
          @blur="nameBlur"
          label="姓名"
          placeholder="请输入"
        />
        <!-- <van-field
          v-model="nineField.sexType"
          label="性别"
          placeholder="性别"
          readonly
        /> -->
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>性别</span></div>
          <div class="van-cell__value van-field__value sex_content">
            <div class="van-field__body sex_container">
              <div
                class="sex_bth"
                :class="{'sex_checked_btn': nineField.sexType === 1}"
                @click="nineField.sexType = 1">男</div>
              <div
                class="sex_bth"
                :class="{'sex_checked_btn': nineField.sexType === 2}"
                @click="nineField.sexType = 2">女</div>
            </div>
          </div>
        </div>
        <van-field
          v-model="nineField.birthday"
          right-icon="arrow"
          label="出生日期"
          readonly
          placeholder="请选择"
          @click="showBirthdayTimePopup = true"
        />
        <van-field
          v-model="nineField.city"
          right-icon="arrow"
          label="现居住城市"
          readonly
          placeholder="请选择"
          @click="cityShow = true"
        />
        <van-field
          v-model="nineField.education"
          right-icon="arrow"
          label="最高学历"
          readonly
          placeholder="请选择"
          @click="educationShow = true"
        />
        <van-field
          ref="schoolName"
          v-model="nineField.schoolName"
          @blur="schoolNameBlur"
          label="学校名称"
          placeholder="请输入"
        />
        <van-field
          ref="majorName"
          v-model="nineField.majorName"
          @blur="majorNameBlur"
          label="所学专业"
          placeholder="请输入"
        />
        <!-- <van-field
          v-model="nineField.time"
          label="在校时间"
          placeholder="在校时间"
          readonly
          @click="showSchoolTimePopup = true"
        /> -->
        <div class="van-cell van-field school_time_cell">
          <div class="van-cell__title van-field__label"><span>在校时间</span></div>
          <div class="van-cell__value van-field__value sex_content">
            <div class="van-field__body time_container">
              <input
                v-model="nineField.startDate"
                type="text"
                class="van-field__control time_start"
                readonly
                placeholder="请选择开始时间"
                @click="selectDate('start')"
              />
              <span class="time_line"></span>
              <input
                v-model="nineField.endDate"
                type="text"
                class="van-field__control time_end"
                readonly
                placeholder="结束时间"
                @click="selectDate('end')"
              />
              <div class="van-field__right-icon">
                <!-- <i class="van-icon van-icon-arrow"></i> -->
              </div>
            </div>
          </div>
        </div>
        <van-popup v-model="showBirthdayTimePopup" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="请选择出生日期"
            :minDate="minDate"
            :maxDate="maxDate"
            @confirm="confirmBirthday"
            @cancel="
              () => {
                this.showBirthdayTimePopup = false;
              }
            "
          />
        </van-popup>
        <van-popup v-model="showSchoolTimePopup" position="bottom">
          <van-datetime-picker
            v-model="schoolDate"
            type="year-month"
            :title="schoolTimeTitle"
            :minDate="minDate"
            @confirm="confirmSchoolTime"
            @cancel="handleSchoolTimeCancel"
          />
        </van-popup>
        <van-popup v-model="cityShow" position="bottom">
          <div class="header-opt-area">
            <span class="cancle-btn" @click="cancelPopup">取消</span>
            <span class="opt-content">请选择现居住城市</span>
            <span class="save-btn" @click="savePopup">确定</span>
          </div>
          <van-tree-select
            :items="areaItems"
            :active-id.sync="activeId"
            :main-active-index.sync="activeIndex"
            @click-item="cityChange"
          />
        </van-popup>
        <van-popup v-model="educationShow" position="bottom">
          <van-picker
            :default-index="currentEducationIndex"
            show-toolbar
            title="请选择最高学历"
            :columns="educationData"
            value-key="value"
            @confirm="confirmEducation"
            @cancel="
              () => {
                this.educationShow = false;
              }
            "
          />
        </van-popup>
        <van-field
          v-model="nineField.email"
          v-show="showEmailField === 1"
          @blur="emailBlur"
          label="邮箱"
          placeholder="请输入"
        />
      </div>
    </div>
    <footer>
      <van-button
        class="submit_btn"
        :class="{'submit_btn_allow': submitFlag}"
        type="info"
        @click="submit"
      >提交并进入活动</van-button>
    </footer>
    <van-popup
      class="no-disturb"
      v-model="noDisturbShow"
      position="bottom">
      <div class="no-disturb-reminder">向您推荐优质职位消息</div>
      <div class="no-disturb-container">
        <van-button
          class="button-refuse"
          type="info"
          round
          @click="handleRefuse"
        >拒绝</van-button>
        <van-button
          class=""
          type="info"
          round
          @click="handleAllow"
        >允许</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { dateFormat } from "@/utils/dateFormat";
import {
  userSubmit,
  getProvinceList,
  getEducation,
  userOpen,
  hideUserResume,
} from "@/api";
export default {
  data() {
    const date = new Date();
    let year = date.getFullYear();
    let maxDate = new Date(date.setYear(year - 16));
    let defaultBirthday = new Date(date.setYear(year - 21));
    let defaultSchoolDate = new Date(date.setYear(year - 3));
    return {
      minDate: new Date(1950, 0, 1),
      maxDate: maxDate,
      currentDate: defaultBirthday,
      currentEducationIndex: 0,
      showSchoolTimePopup: false,
      showBirthdayTimePopup: false,
      nineField: {
        activityShareId: '',
        name: "",
        sexType: 1,
        birthday: "",
        city: "",
        cityId: "",
        education: "",
        eduLevel: "",
        schoolName: null,
        majorName: null,
        startDate: null,
        endDate: null,
        email: "",
      },
      cityShow: false,
      areaItems: [],
      activeId: 0,
      activeIndex: 0,
      schoolTimeTitle: "请选择开始时间",
      schoolDate: defaultSchoolDate,
      defaultStart: 18,
      defaultEnd: 4,
      schoolTimeType: "start",
      educationData: [],
      educationShow: false,
      submitFlag: false,
      showFlag: false,
      bannerUrl: '',
      showEmailField: 2, // 1显示，2不显示
      noDisturbShow: false,
      redirectUrl: '', // 提交成功后落地页
      activityId: '', // url中没有activityId时从userOpen取
    };
  },
  async created() {
    window.pageYoffset = 1;
    document.documentElement.scrollTop = 1;
    document.body.scrollTop = 1;
    await this.loadEducation();
    await this.loadProvinceList();
    await this.userOpen();
  },
  watch: {
    nineField: {
      handler () {
        const keys = Object.keys(this.nineField);
        this.submitFlag = keys.every((ele) => this.checkIptNoTip(ele));
      },
      deep: true
    }
  },
  methods: {
    schoolNameFormatter (value) {
      return value.replace(/(.*[0-9]{6,}.*)|(^[^0-9A-Za-z\(\)\（\）\u4E00-\u9FA5].*)|(^[0-9]*$)|(^[0-9][^A-Za-z\u4E00-\u9FA5]*[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*[0-9][^A-Za-z\u4E00-\u9FA5]*$)|(^[^A-Za-z\u4E00-\u9FA5]+$)/g, '');
    },
    majorNameFormatter (value) {
      return value.replace(/(^[0-9]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5]+$)|(^[0-9][^A-Za-z\u4E00-\u9FA5]*[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*$)|(^[^0-9A-Za-z\u4E00-\u9FA5][^A-Za-z\u4E00-\u9FA5]*[0-9][^A-Za-z\u4E00-\u9FA5]*$)/g, '');
    },
    nameBlur (event) {
      event.target.value = event.target.value.replace(/\n/g, '');
      let value = event.target.value;
      if (value) {
        this.blurFn(value.length, 2, 20, '姓名');
      }
    },
    schoolNameBlur (event) {
      event.target.value = event.target.value.replace(/\n/g, '');
      let value = event.target.value;
      if (value) {
        this.blurFn(value.length, 2, 70, '学校名称');
      }
    },
    majorNameBlur (event) {
      // let value = event.target.value.replace(/[^\x00-\xff]/g, 'AA');
      event.target.value = event.target.value.replace(/\n/g, '');
      let value = event.target.value;
      if (value) {
        this.blurFn(value.length, 2, 30, '专业名称');
      }
    },
    emailBlur (event) {
      event.target.value = event.target.value.replace(/\n/g, '');
      let value = event.target.value;
      if (value) {
        this.blurFn(value.length, 0, 50, '邮箱', event.target.value);
      }
    },
    blurFn (length, min, max, name, value) {
      if (name === '邮箱') {
        if (min <= length && length <= max) {
          if (length > 0) {
            const regMail = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
            if (!regMail.test(value)) {
              this.$notify({ type: "warning", message: `请输入正确格式的邮箱`, duration: 2 * 1000, });
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          this.$notify({ type: "warning", message: `邮箱请输入${max}个字符以内`, duration: 2 * 1000, });
          return false;
        }
      } else {
        if (min <= length && length <= max) {
          return true;
        } else {
          this.$notify({ type: "warning", message: `${name}请输入${min}-${max}个字符`, duration: 2 * 1000, });
          return false;
        }
      }
    },
    positionSchoolDate (type) {
      // 定位默认时间
      let birthday;
      if (this.nineField.birthday) {
        let newDate = this.nineField.birthday.replace('-', '/')
        birthday = new Date(`${newDate}/1`);
      } else {
        birthday = new Date(this.currentDate);
      }
      let year = birthday.getFullYear();
      let startDate = new Date(birthday.setYear(year + this.defaultStart));
      if (this.nineField.startDate) {
        let newStartDate = this.nineField.startDate.replace('-', '/')
        startDate = new Date(`${newStartDate}/1`);
      }
      let startYear = startDate.getFullYear();
      if (type === 'start') {
        this.schoolDate = startDate;
      } else {
        this.schoolDate = new Date(startDate.setYear(startYear + this.defaultEnd));
      }
    },
    confirmBirthday(val) {
      this.nineField.birthday = dateFormat(val);
      this.currentDate = val;
      this.showBirthdayTimePopup = false;
    },
    confirmEducation (val) {
      this.nineField.education = val.value;
      this.nineField.eduLevel = val.numberKey;
      this.educationShow = false;
      // 设置在校开始时间:出生年份+defaultStart; 在校结束时间:开始时间+defaultEnd;
      switch (val.numberKey) {
        case 9: // 初中及以下
          this.defaultStart = 12;
          this.defaultEnd = 3;
          break;
        case 7: // 高中
          this.defaultStart = 15;
          this.defaultEnd = 3;
          break;
        case 12: // 中专/中技
          this.defaultStart = 15;
          this.defaultEnd = 3;
          break;
        case 5: // 大专
          this.defaultStart = 18;
          this.defaultEnd = 3;
          break;
        case 4: // 本科
          this.defaultStart = 18;
          this.defaultEnd = 4;
          break;
        case 3: // 硕士
          this.defaultStart = 22;
          this.defaultEnd = 3;
          break;
        case 10: // MBA/EMBA
          this.defaultStart = 25;
          this.defaultEnd = 2;
          break;
        case 1: // 博士
          this.defaultStart = 25;
          this.defaultEnd = 5;
          break;
        default:
          break;
      }
    },
    selectDate (type) {
      if (type === 'start') {
        if (!this.nineField.startDate) {
          this.positionSchoolDate('start');
        } else {
          this.schoolDate = new Date(this.nineField.startDate);
        }
        this.schoolTimeType = 'start';
        this.schoolTimeTitle = '请选择开始时间';
      } else {
        if (!this.nineField.endDate) {
          this.positionSchoolDate('end');
        } else {
          this.schoolDate = new Date(this.nineField.endDate);
        }
        this.schoolTimeType = 'end';
        this.schoolTimeTitle = '请选择结束时间';
      }
      this.showSchoolTimePopup = true;
    },
    confirmSchoolTime (val) {
      if (this.schoolTimeType === 'start') {
        this.nineField.startDate = dateFormat(val);
        this.showSchoolTimePopup = false;
      } else if (this.schoolTimeType === 'end') {
        if (this.checkDate(this.nineField.startDate, val)) {
          this.nineField.endDate = dateFormat(val);
          this.showSchoolTimePopup = false;
        }
      }
    },
    handleSchoolTimeCancel () {
      if (this.schoolTimeType === 'start') {
        this.showSchoolTimePopup = false;
      } else if (this.schoolTimeType === 'end') {
        this.schoolTimeTitle = '请选择开始时间';
        this.schoolTimeType = 'start';
      }
    },
    cancelPopup() {
      this.cityShow = false;
    },
    savePopup() {
      if (!this.activeId) {
        this.$notify({
          type: "warning",
          message: "请选择右侧城市",
          duration: 2 * 1000,
        });
        return
      }
      let { id: cid, text: ctext } = this.currentCity;
      let province = this.areaItems.filter((item) => {
        if (item.id === cid) {
          return item;
        } else {
          return (
            item.children &&
            item.children.filter((child) => child.id === cid)[0]
          );
        }
      });
      let provinceObj = province[0] || {};
      this.nineField.city =
        provinceObj.text == ctext ? ctext : `${ctext}`;
      this.nineField.cityId = cid;
      this.cityShow = false;
      this.activeId = cid;
    },
    cityChange(val) {
      this.currentCity = val;
    },
    submit() {
      console.log(this.nineField);
      let keys = Object.keys(this.nineField);
      let flag = keys.every((ele) => this.checkIpt(ele));
      if (this.$route.query.activityShareId === '-1') {
        this.$set(this.nineField, 'activityId', this.$route.query.activityId);
      }
      if (
        flag &&
        this.checkDate(
          this.nineField.startDate,
          this.nineField.endDate
        ) &&
        this.blurFn(this.nineField.name.length, 2, 20, '姓名') &&
        this.blurFn(this.nineField.schoolName.length, 2, 70, '学校名称') &&
        this.blurFn(this.nineField.majorName.length, 2, 30, '专业名称') &&
        this.blurFn(this.nineField.email.length, 0, 50, '邮箱', this.nineField.email)
      ) {
        userSubmit(this.nineField).then((res) => {
          if (res && res.status == 200) {
            const data = res.data;
            if (data.success) {
              if (data.data.hasAlreadyJoinActivity) {
                this.$dialog.alert({
                  message: '已参加过活动，请勿重复参与',
                }).then(() => {
                  this.jumpNewUrl(data.data.redirectUrl);
                });
              } else {
                if (data.data.hideStatus === 1) { // 1打开弹框，2不打开
                  this.redirectUrl = data.data.redirectUrl;
                  this.noDisturbShow = true;
                } else {
                  this.jumpNewUrl(data.data.redirectUrl);
                }
              }
            } else {
              this.$notify({
                type: "warning",
                message: data.apiErrorMessage,
                duration: 3 * 1000,
              });
            }
          }
        });
      }
    },
    jumpNewUrl (redirectUrl) {
      if (this.$route.query.taskId) {
        const orgin = location.origin;
        let url =
          `${orgin}/#/helpActivity?` +
          `&taskSenderId=${this.$route.query.taskSenderId}` +
          `&activityId=${this.$route.query.activityId}` +
          `&shareId=${this.$route.query.shareId}` +
          `&taskId=${this.$route.query.taskId}`;
        location.href = url;
      } else {
        location.href = redirectUrl;
      };
    },
    checkIpt(key) {
      if (key !== 'email') {
        if (
          this.nineField[key] == "" ||
          this.nineField[key] == null ||
          this.nineField[key] == undefined
        ) {
          this.$notify({
            type: "warning",
            message: this.checkKey(key) + "不能为空",
            duration: 2 * 1000,
          });
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkIptNoTip(key) {
      if (key !== 'email') {
        if (
          this.nineField[key] == "" ||
          this.nineField[key] == null ||
          this.nineField[key] == undefined
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkDate(start, end) {
      if (end) {
        if (new Date(start) > new Date(end)) {
          this.$notify({
            type: "warning",
            message: "开始时间不能大于结束时间",
            duration: 3 * 1000,
          });
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkKey(key) {
      switch (key) {
        case "name":
          return "姓名";

        case "sexType":
          return "性别";

        case "birthday":
          return "出生日期";

        case "cityId":
          return "现居住城市";

        case "eduLevel":
          return "最高学历";

        case "schoolName":
          return "学校名称";

        case "majorName":
          return "所学专业";

        case "startDate":
          return "在校开始时间";

        case "endDate":
          return "在校结束时间";

        case "activityShareId":
          return "activityShareId";
        
        case "activityUserId":
          return "activityUserId";

        case "email":
          return "邮箱";

        default:
          break;
      }
    },
    deleteKey(data) {
      if (data) {
        data.map((ele) => {
          if (ele.children.length <= 0) {
            delete ele.children;
          } else {
            this.deleteKey(ele.children);
          }
        });
      }
    },
    async loadProvinceList() {
      let data = await getProvinceList();
      if (data.status === 200) {
        let datas = data.data;
        let areaList = datas.map((item) => {
          let childrens = null;
          if (!item.children || (item.children && item.children.length == 0)) {
            childrens = [{ id: item.numberKey, text: item.value }];
          } else {
            childrens = item.children.map((child) => {
              return {
                id: child.numberKey,
                text: child.value,
              };
            });
          }
          return {
            id: item.numberKey,
            text: item.value,
            children: childrens,
          };
        });
        this.areaItems = areaList;
      }
    },
    async loadEducation() {
      let data = await getEducation();
      if (data.status === 200) {
        this.educationData = data.data.map(item => {
          return item
        })
      }
    },
    async userOpen () {
      const data = {
        activityShareId: this.$route.query.activityShareId,
        isNew: this.$route.query.isNew || 0
      }
      if (this.$route.query.activityShareId === '-1') { // 自然流量
        data.activityId = this.$route.query.activityId;
      }
      const res = await userOpen(data);
      if (res && res.status == 200) {
        if (res.data.errorCode === 420) {
          this.$router.push({
            name: '404'
          })
        }
        const data = res.data.data;
        this.bannerUrl = data.bannerUrl;
        this.activityId = data.activityId;
        if (data.redirectUrl) { // 判断有无简历
          if (this.$route.query.taskId) {
            const orgin = location.origin;
            let url =
              `${orgin}/#/helpActivity?` +
              `&taskSenderId=${this.$route.query.taskSenderId}` +
              `&activityId=${this.$route.query.activityId}` +
              `&shareId=${this.$route.query.shareId}` +
              `&taskId=${this.$route.query.taskId}`;
            location.href = url;
          } else {
            location.href = data.redirectUrl;
          }
        } else {
          this.showFlag = true;
          this.showEmailField = data.showEmailField;
          this.nineField = data;
          delete this.nineField.redirectUrl;
          delete this.nineField.bannerUrl;
          if (data.cityId) {
            this.activeId = data.cityId;
            this.areaItems.forEach((ele, index) => {
              ele.children.forEach((e) => {
                if (e.id == data.cityId) {
                  this.nineField.city = e.text;
                  this.activeIndex = index;
                }
              });
            });
          }
          if (data.eduLevel) {
            this.currentEducationIndex = this.educationData.findIndex(item => {
              return item.numberKey === data.eduLevel;
            })
            this.$set(this.nineField, 'education', this.educationData[this.currentEducationIndex].value);
          }
          if (data.birthday) {
            let newDate = data.birthday.replace('-', '/');
            this.currentDate = new Date(`${newDate}/1`);
          }
        }
      }
    },
    handleRefuse () {
      hideUserResume({ activityId: this.activityId }).then(res => {
        if (res && res.status == 200) {
          const data = res.data;
          if (data.success) {
            this.jumpNewUrl(this.redirectUrl);
          } else {
            this.$notify({
              type: "warning",
              message: data.apiErrorMessage,
              duration: 3 * 1000,
            });
          }
        }
      })
    },
    handleAllow () {
      this.jumpNewUrl(this.redirectUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.nine_field_resume {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  header {
    position: relative;
    height: 36.5vw;
    overflow: hidden;
    img {
      display: block;
    }
  }
  header:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10px;
    border-radius: 12px 12px 0 0;
    background-color: #fff;
  }
  .nine_field_resume_content {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 10px;
    .nine_field_resume_container {
      padding: 0 0 5px;
      overflow: hidden;
      /deep/ .van-cell {
        margin-bottom: 0;
        // border-bottom: 1px solid #f7f7f7;
        position: relative;
        padding: 15px 0 8px 0 !important;
        .van-field__label {
          flex: 1;
          color: #555;
          display: flex;
          align-items: center;
          padding-left: 28px;
          font-weight: normal;
          font-size: 15px;
        }
        .sex_content {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .van-field__value {
          flex: 2;
          background: none;
          box-sizing: border-box;
          padding-right: 23px;
          height: 30px;
          line-height: 30px;
          .van-field__right-icon {
            width: 10px;
            height: 30px;
            padding: 0;
            margin: 0 -5px 0 5px;
            background: url('../../assets/imgs-2021/right.png') center center no-repeat;
            background-size: 6px;
            .van-icon-arrow::before {
              display: none;
            }
          }
          .van-field__control {
            text-align: right;
            font-size: 14px;
            width: 100%;
          }
          .sex_container {
            .sex_bth {
              height: 32px;
              width: 32px;
              line-height: 32px;
              text-align: center;
              font-weight: bold;
              color: #999;
              border-radius: 4px;
              margin-left: 10px;
              font-size: 14px;
            }
            .sex_checked_btn {
              background-color: #1A8AFA;
              color: #fff;
            }
          }
          .time_container {
            display: flex;
            justify-content: space-between;
            .van-field__control {
              padding: 0;
            }
            .time_start {
              width: 120px;
            }
            .time_line {
              width: 6px;
              position: relative;
            }
            .time_line:after {
              content: '';
              position: absolute;
              left: 6px;
              top: -1px;
              width: 8px;
              height: 1px;
              background-color: #999;
            }
            .time_end {
              width: 70px;
            }
          }
        }
      }
      /deep/ .van-cell:first-child {
        padding-top: 10px !important;
      }
      /deep/ .van-cell::after {
        position: absolute;
        content: '';
        bottom: 1px;
        left: 20px;
        right: 20px;
        height: 2px;
        background-color: #f7f7f7;
        display: block !important;
      }
      .school_time_cell {
        .van-field__label {
          flex: 1;
        }
        .van-field__value {
          flex: 2.5;
        }
      }
    }
  }
  footer {
    text-align: center;
    padding: 15px 15px 25px;
    .submit_btn {
      width: 335px;
      height: 48px;
      border: none;
      border-radius: 24px;
      background: #c6c6c6;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
    }
    .submit_btn_allow {
      background: #1A8AFA;
    }
  }
}
.header-opt-area {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  .cancle-btn {
    padding: 0 16px;
    font-size: 14px;
    color: #969799;
  }
  .opt-content {
    max-width: 50%;
    font-weight: 500;
    font-size: 16px;
  }
  .save-btn {
    padding: 0 16px;
    font-size: 14px;
    color: #576b95;
  }
}

.no-disturb {
  height: 100vw * 200 / 375;
  padding: 0 100vw * 54 / 375;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .no-disturb-reminder {
    font-size: 22px;
    font-weight: bold;
    font-family: PingFangSC-Medium, PingFang SC;
    letter-spacing: 1px;
  }
  .no-disturb-container {
    display: flex;
    justify-content: space-between;
    .van-button {
      width: 100vw * 120 / 375;
      background-color: #1A8AFA;
      border-color: #1A8AFA;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 1px;
    }
    .button-refuse {
      background-color: #F3F9FF;
      border-color: #86C1FC;
      color: #1A8AFA;
    }
  }
}
</style>